import { z } from 'zod';
import { DepartmentSchema } from '../../entities/department/department.schema';
import { IncludeDeletedRequestSchema } from '../../shared/include-deleted.schema';
/**
 * List Departments Request Schema
 * GET /api/v2/departments
 */ export const ListDepartmentsRequestSchema = IncludeDeletedRequestSchema;
/**
 * List Departments Response Schema
 * GET /api/v2/departments
 */ export const ListDepartmentsResponseSchema = z.object({
    data: z.array(DepartmentSchema)
});

//# sourceMappingURL=list-departments.schema.js.map